// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2eJH-","label":"Completed_label__3BwVN"};